import { Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { HgService } from "src/app/services/http/hg.service";
import { LaudoUnionService } from "src/app/services/http/laudo-union.service";
import { ModalMsgService } from "src/app/services/modal-msg.service";
import { UtilMasks } from "src/app/utils/util-masks";
import { ClienteAutoAvaliar } from "./../../../../models/ClienteAutoAvaliar";
import { UtilForms } from "./../../../../utils/util-forms";

@Component({
  selector: "app-form-parecer-laudo",
  templateUrl: "./form-parecer-laudo.component.html",
  styleUrls: ["./form-parecer-laudo.component.scss"],
})
export class FormParecerLaudoComponent implements OnInit {
  parecerTecnico: any;
  apontamentos: { status: number; label: string }[] = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private laudoService: LaudoUnionService,
    public msgService: ModalMsgService
  ) {}

  token;
  @Input() modal;
  parecerObs = "";
  textoPadrao = "";
  observacaoFinal: string = "";
  observacaoInicial: string[];
  integracao = false;
  transmitirLaudo = null;
  nomenclaturaParecer = 0;
  parecerNomenclaturas = [
    [
      "Aprovado",
      "Aprovado com restrição",
      "Aprovado com apontamento",
      "Reprovado",
    ],
    [
      "Conforme",
      "Conforme com restrição",
      "Conforme com apontamento",
      "Não conforme",
    ],
    ["Conforme", "Com Restrição", "Com Apontamento", "Não Conforme"],
    ["Sem Apontamento", "", "Com Apontamento", ""],
  ];

  utls: ClienteAutoAvaliar[];
  utlSelecionada: ClienteAutoAvaliar;
  isMultiClienteAutoAvaliar: boolean = false;
  ufs: any;
  ufselecionada: any;

  cnpjManual: any = null;
  masks = {
    cnpj: { mask: UtilMasks.cnpj, guide: false },
  };

  integrahg: boolean = false;

  ngOnInit() {
    this.token = this.activatedRoute.snapshot.params.id || "";
    this.laudoService.getApontamentosLaudo(this.token).then((r) => {
      this.apontamentos = r["apontamentos"];
      let parecerTecnico = r["parecerTecnico"];
      this.parecerTecnico = parecerTecnico["parecerNivel"] || 0;

      this.integracao = r["integracao"] || false;
      this.transmitirLaudo = false;

      this.textoPadrao = parecerTecnico["textoPadrao"] || "";
      this.parecerObs = parecerTecnico["parecerObs"] || "";

      if (this.parecerObs != "") {
        // o símbolo '¤¤' (ALT + 207) será usado para realizar as separações do texto padrão do parecer usando split()
        this.observacaoInicial = this.parecerObs.split("¤¤");

        if (this.observacaoInicial.length > 1) {
          this.textoPadrao = this.observacaoInicial[0] || "";
          this.parecerObs = this.observacaoInicial[1] || "";
        } else if (this.textoPadrao != "") {
          this.parecerObs = this.parecerObs.replace(this.textoPadrao, "");
        }
      }

      this.parecerObs = this.parecerObs.replace("¤¤", "");
      this.textoPadrao = this.textoPadrao.replace("¤¤", "");

      this.nomenclaturaParecer = r["nomenclaturaParecer"] - 1 || 0;

      this.integrahg = r["integrahg"] || false;

    });
  }

  setNivelParecerTecnico(nivel) {
    this.parecerTecnico = nivel;
    document.getElementById("btnM").click();
  }

  confirmar() {

    if (this.cnpjManual != null)
      this.cnpjManual = this.cnpjManual.replace(/[^0-9,]*/g, "");

    // o símbolo '¤¤' (ALT + 207) será usado para realizar as separações do texto padrão do parecer usando split()
    this.observacaoFinal = this.textoPadrao + "¤¤" + this.parecerObs;
    this.observacaoFinal = this.observacaoFinal.trim();

    this.laudoService
      .finalizarLaudo(
        this.token,
        this.parecerTecnico,
        this.observacaoFinal,
        this.transmitirLaudo,
        this.cnpjManual
      )
      .then((r: any) => {
        if (r?.status != null && r?.status?.toUpperCase() == "NAOENCONTRADO") {
          this.msgService.openDialog(
            `PDF do laudo transmitido!`,
            this.isMultiClienteAutoAvaliar 
            ? (`Veículo não encontrado para a unidade ${this.utlSelecionada?.nome || ""} - ${this.cnpjManual || ""}.`)
            : "Veículo não encontrado para a unidade.",
            "danger"
          );
        }
        if (r?.status && r?.status.toUpperCase() == "ERRO" ){
          this.msgService.openDialog(
            `Erro`,
            `Não foi possível transmitir o Laudo em PDF!`,
            "danger"
          );
        }

        this.modal.close("ok");
      })
      .catch((err) => {
        this.msgService.openDialog(
          `Erro`,
          `Erro ao finalizar o laudo`,
          "danger"
        );
      });
  }

  cancelar() {
    this.modal.close("cancel");
  }

  mudarTransmissaoLaudoTerceiros(e) {
    this.transmitirLaudo = e;
    if (e) {
      this.selecionarPatios();
    } else {
      this.resetarVariaveis();
    }
  }

  resetarVariaveis() {
    this.isMultiClienteAutoAvaliar = false;
    this.ufselecionada = null;
    this.utlSelecionada = null;
    this.utls = null;
    this.ufs = null;
  }

  selecionarPatios() {
    if (this.ufs == null || this.ufs.length == 0) {
      this.ufs = [...UtilForms.optionsEstado.nome];
    }
    this.laudoService
      .getUnidadesMultiClientAutoAvaliar(this.token, this.ufselecionada?.value)
      .then((r) => {
        if (r[0]?.isMultiClienteAutoAvaliar == false) {
          this.isMultiClienteAutoAvaliar = false;
        } else if (r.length > 0) {
          this.utls = r;
          this.isMultiClienteAutoAvaliar = true;
        } else {
          this.utls = null;
          this.utlSelecionada = null;
          this.isMultiClienteAutoAvaliar = true;
        }
      });
  }
}
